import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { BaseAccount } from '@shared/models/base-account';
import { AccountDisplayNamePipe } from '@shared/pipes/account-display-name.pipe';

@Component({
  selector: 'app-account-signature',
  templateUrl: './account-signature.component.html',
  styleUrls: ['./account-signature.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatTooltip, AccountDisplayNamePipe]
})
export class AccountSignatureComponent {
  readonly account = input.required<BaseAccount>();
  readonly onlyAvatar = input(false);
  readonly displayTooltip = input(true);
}
